module.exports = __webpack_public_path__ + "media/images/favicon/favicon-10c5bb3f045972afcacc1625d5c761c5.ico";